import { render, staticRenderFns } from "./JdsCallout.vue?vue&type=template&id=fdf6a9c6&scoped=true&"
import script from "./JdsCallout.vue?vue&type=script&lang=ts&"
export * from "./JdsCallout.vue?vue&type=script&lang=ts&"
import style0 from "./JdsCallout.vue?vue&type=style&index=0&id=fdf6a9c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdf6a9c6",
  null
  
)

export default component.exports